import api from './api'

const DEFAULT_SHARE = {
  title: '北外滩国际航运论坛',
  desc: '北外滩国际航运论坛唯一官网',
  imgUrl: window.location.origin + '/share-logo.png',
}

let callId = 0

/**
 * 初始化微信分享
 * @param {Object} shareData - { title, desc, link, imgUrl }
 */
export function initWxShare(shareData = {}) {
  if (!/micromessenger/i.test(navigator.userAgent)) return

  const wx = window.wx
  if (!wx) return

  const currentCallId = ++callId
  const currentUrl = window.location.href.split('#')[0]
  const data = {
    title: shareData.title || DEFAULT_SHARE.title,
    desc: shareData.desc || DEFAULT_SHARE.desc,
    link: shareData.link || currentUrl,
    imgUrl: shareData.imgUrl || DEFAULT_SHARE.imgUrl,
  }

  api.get('/api/weixin/jssdk_config', { url: currentUrl }).then(res => {
    if (currentCallId !== callId) return

    wx.config({
      debug: res.debug || false,
      appId: res.appId,
      timestamp: parseInt(res.timestamp, 10),
      nonceStr: res.nonceStr,
      signature: res.signature,
      jsApiList: res.jsApiList || [
        'updateAppMessageShareData',
        'updateTimelineShareData',
      ],
    })

    wx.ready(function () {
      wx.updateAppMessageShareData({
        title: data.title,
        desc: data.desc,
        link: data.link,
        imgUrl: data.imgUrl,
      })
      wx.updateTimelineShareData({
        title: data.title,
        link: data.link,
        imgUrl: data.imgUrl,
      })
    })

    wx.error(function (res) {
      console.error('wx.config error:', res)
    })
  }).catch(err => {
    console.error('获取 JSSDK 配置失败:', err)
  })
}
